module.exports = __webpack_public_path__ + "static/media/garlicHeroImage.2ba1323d.png";